// import logo from './logo.svg';
import './App.css';
import React, {
  useState,
  useEffect,
  lazy,
  createContext,
} from 'react';
// import {
//   Component,
// } from 'react';

import {
  // BrowserRouter,
  Routes,
  Route,
  // useLocation,
} from 'react-router-dom';

import ProtectedRoute from './auth/ProtectedRoute';
import ScoutLayout from './pages/DigitalAssistants/Layout';

import SignUpJoin from './auth/Invite/SignUpJoin';
import Invite from './pages/Users/Invite';
import AcceptInvite from './pages/Users/AcceptInvite';
import SpeciaHome from './pages/SpeciaHome/SpeciaHome';
import MyDigitalWorker from './pages/MyDigitalWoker/MyDigitalWorker';

// set up account
import SetupPage from './pages/SetupSpecia/SetupPage';

import EmployeeSetup from './pages/SetupSpecia/EmployeeSetup';

import CompanySetup from './pages/SetupSpecia/CompanySetup';

// store
import Store from './pages/Store/Store';
import Accounting from './pages/Store/Accounting';
import DetailStore from './pages/Store/DetailStore';

// set up ato
import GayatriSetup from './pages/Gayatri/SetUp/GayatriSetup';

import ScoutSetup from './pages/DigitalAssistants/InitialSetUp/ScoutSetup';

// gayatri setting
// import GayatriSettings from './pages/Gayatri/Settings/GayatriSettings';

// manage clients
import ManageClients from './pages/Gayatri/ManageClients/ManageClients';

// manage Users
import ManageUsers from './pages/Gayatri/ManageUsers/ManageUsers';

// workpaper
import Workpaper from './pages/Gayatri/Workpaper/Workpaper';
import GenerateWorkpaper from './pages/Gayatri/Workpaper/GenerateWorkpaper';

// Omni imports
import OmniLayout from './pages/Omni/Layout';
import OmniManageClients from './pages/Omni/ManageClients/ManageClients';
import OmniReports from './pages/Omni/Reports/Reports';
import OmniSettings from './pages/Omni/Settings/OmniSettings';

// Eva imports
import EvaLayout from './pages/Eva/Layout';
import EvaManageClients from './pages/Eva/ManageClients/ManageClients';
import EvaReports from './pages/Eva/Reports/Reports';
import EvaSettings from './pages/Eva/Settings/OmniSettings';

// Atlas imports
import AtlasLayout from './pages/Atlas/Layout';
import AtlasReports from './pages/Atlas/Reports/Documents';



// setting
import Setting from './pages/Setting/Settings';
import ScoutSettings from './pages/DigitalAssistants/Settings/ScoutSettings';
import GaytriLayout from './pages/Gayatri/Layout';
import SetUpRequired from './pages/Gayatri/SetUpRequired';
import Landing from './pages/Landing/Landing';
import SubscriptionRequired from './pages/Gayatri/Subscription/SubscriptionRequired';

import SubscriptionResult from './pages/Gayatri/Subscription/SubscriptionResult';
import AddClients from './pages/Gayatri/ManageClients/AddClients';

import Cookies from 'universal-cookie';
import MenuBarNew from './utils/MenuBarNew';
import { Snackbar } from '@mui/material';
import Solutions from './pages/Landing/Solutions';
import Pricing from './pages/Landing/Pricing';
import Contact from './pages/Landing/Contact';
import About from './pages/Gayatri/About';
import SharedClients from './pages/SharedClients/SharedClients';
import SessionExpiredModal from './utils/SessionExpiredModal';
import LandingLayout from './pages/Landing/LandingLayout';
import HomeLayout from './utils/HomeLayout';

const DigitalAssistants = lazy(() => import('./pages/DigitalAssistants/DigitalAssistants'));
const Registration = lazy(() => import('./auth/registration/Registration'));
const Login2 = lazy(() => import('./auth/login/Login2'));
const Logout = lazy(() => import('./auth/login/Logout'));
const Home = lazy(() => import('./pages/Home/Home'));
const SelectTier = lazy(() => import('./pages/DigitalAssistants/SetUp/Reporter/SelectTier'));
const ClientSetUp = lazy(() => import('./pages/DigitalAssistants/SetUp/Reporter/ClientSetUp'));
const FinishedScreen = lazy(() => import('./pages/DigitalAssistants/SetUp/Reporter/FinishedScreen'));
const Reporter = lazy(() => import('./pages/DigitalAssistants/Reporter'));
const ReporterCreateRequest = lazy(() => import('./pages/DigitalAssistants/CreateRequest/ATOReporter/ReporterCreateRequest'));
const ReporterViewReports = lazy(() => import('./pages/DigitalAssistants/ViewReports/ATOReporter/ReporterViewReports'));
const ReporterViewRequests = lazy(() => import('./pages/DigitalAssistants/ViewRequests/ATOReporter/ReporterViewRequests'));
const DisplayReports = lazy(() => import('./pages/DigitalAssistants/ViewReports/ATOReporter/DisplayReports'));
const AccountantDetails = lazy(() => import('./auth/updateinfo/AccountantDetails'));
const InfoUpdated = lazy(() => import('./auth/updateinfo/InfoUpdated'));

const cookies = new Cookies();

export const SnackbarContext = createContext(null);

cookies.set('currentPath', window.location.pathname + window.location.search, { path: '/' });

function App() {
  const [
    snackBarShow,
    setSnackBarShow,
  ] = useState(false);
  const [
    snackBarMessage,
    setSnackBarMessage,
  ] = useState('');

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarShow(false);
  };

  console.log(window.location.pathname);
  const [
    menuBarShow,
    setMenuBarShow,
  ] = useState(false);

  const menuBarOpenHandler = () => {
    setMenuBarShow(true);
  };

  const menuBarCloseHandler = () => {
    setMenuBarShow(false);
  };

  return (
    <>
      <SnackbarContext.Provider value={{ snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired }}>
        <Routes>

          <Route path="/landing" element={<LandingLayout />}>

            <Route index element={<Landing />} />
            <Route path="solutions" element={<Solutions />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="contact" element={<Contact />} />

          </Route>

          <Route path="/auth/login" element={<Login2 />} />
          <Route path="/auth/logout" element={<Logout />} />
          <Route path="/auth/register" element={<Registration />} />
          <Route path="/invite/accepted" element={<AcceptInvite />} />
          <Route path="/invite/existing" element={<Invite />} />
          <Route path="/invite/new" element={<SignUpJoin />} />

          <Route path="/" element={<ProtectedRoute />}>

            <Route path="/" element={<HomeLayout />}>
              {/* shared clients */}
              <Route path="clients" element={<SharedClients />} />

              {/* setting */}
              <Route path="setting" element={<Setting menuBarOpen={menuBarOpenHandler} />} />

              <Route index element={<SpeciaHome menuBarOpen={menuBarOpenHandler} menuBarClose={menuBarCloseHandler} />} />
            </Route>

            <Route path="MyDigitalWorker" element={<MyDigitalWorker menuBarOpen={menuBarOpenHandler} />} />

            {/* set up page */}
            <Route path="setup" element={<SetupPage />} />
            <Route path="setup/emp" element={<EmployeeSetup />} />
            <Route path="setup/owner" element={<CompanySetup />} />

            {/* store */}
            <Route path="store" element={<Store />} />
            <Route path="store/accounting" element={<Accounting />} />
            <Route path="store/detail/:id" element={<DetailStore />} />

            <Route path="mydigitalworkers/gayatri/subscription" element={<SubscriptionRequired />}></Route>

            <Route path="/mydigitalworkers/gayatri/subscription/resolved" element={<SubscriptionResult />} />

            <Route path="mydigitalworkers/gayatri/setup" element={<GayatriSetup />}></Route>

            <Route path="mydigitalworkers/gayatri" element={<GaytriLayout />}>
              {/* manage clients */}
              <Route path="clients" element={<ManageClients />}></Route>
              <Route path="clients/new" element={<AddClients />}></Route>

              {/* generate workpaper */}
              <Route path="workpapers" element={<Workpaper />}></Route>
              {/* <Route path="workpapers/create" element={<GenerateWorkpaper />}></Route> */}

              {/* view */}
              <Route path="about" element={<About />}></Route>
              {/* <Route path="/industries/accounting/gayatri/JournalEntry" element={<JournalEntry />}></Route>
              <Route path="/industries/accounting/gayatri/JournalEntry/SubmitJournalEntry" element={<SubmitJournalEntry />}></Route> */}

              {/* gaytri setting */}
              {/* <Route path="settings" element={<GayatriSettings />}></Route> */}

            </Route>

            <Route path="mydigitalworkers/omni" element={<OmniLayout />}>
              {/* manage clients */}
              <Route path="clients" element={<OmniManageClients />}></Route>

              {/* generate workpaper */}
              <Route path="reports" element={<OmniReports />}></Route>
              {/* <Route path="workpapers/create" element={<GenerateWorkpaper />}></Route> */}

              {/* view */}
              <Route path="about" element={<About />}></Route>
              {/* <Route path="/industries/accounting/gayatri/JournalEntry" element={<JournalEntry />}></Route>
              <Route path="/industries/accounting/gayatri/JournalEntry/SubmitJournalEntry" element={<SubmitJournalEntry />}></Route> */}

              {/* gaytri setting */}
              <Route path="settings" element={<OmniSettings />}></Route>

            </Route>

            <Route path="mydigitalworkers/Eva" element={<EvaLayout />}>
              {/* manage clients */}
              <Route path="clients" element={<EvaManageClients />}></Route>

              {/* generate workpaper */}
              <Route path="reports" element={<EvaReports />}></Route>
              {/* <Route path="workpapers/create" element={<GenerateWorkpaper />}></Route> */}

              {/* view */}
              {/* <Route path="about" element={<About/>}></Route> */}
              {/* <Route path="/industries/accounting/gayatri/JournalEntry" element={<JournalEntry />}></Route>
              <Route path="/industries/accounting/gayatri/JournalEntry/SubmitJournalEntry" element={<SubmitJournalEntry />}></Route> */}

              {/* gaytri setting */}
              <Route path="settings" element={<EvaSettings />}></Route>

            </Route>

            <Route path="mydigitalworkers/atlas" element={<AtlasLayout />}>
              {/* generate workpaper */}
              <Route path="documents" element={<AtlasReports />}></Route>
              {/* <Route path="workpapers/create" element={<GenerateWorkpaper />}></Route> */}

            </Route>



            <Route path="mydigitalworkers/Scout/setup" element={<ScoutSetup />}></Route>

            <Route path="mydigitalworkers/Scout" element={<ScoutLayout />}>
              <Route path="home" element={<Home />} />
              <Route path="clients" element={<ClientSetUp />} />
              <Route path="setup/success" element={<FinishedScreen />} />
              <Route path="requests/create" element={<ReporterCreateRequest />} />
              <Route path="requests" element={<ReporterViewRequests />} />
              <Route path="reports" element={<ReporterViewReports />} />
              <Route path="reports/view" element={<DisplayReports />} />
              <Route path="settings" element={<ScoutSettings />} />
            </Route>
          </Route>
        </Routes>
        <div>
          <Snackbar
            open={snackBarShow}
            autoHideDuration={3000}
            onClose={handleClose}
            message={snackBarMessage}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          />
        </div>
      </SnackbarContext.Provider>
      <MenuBarNew show={menuBarShow} closeHandler={() => setMenuBarShow(false)} />

      {/* <ModalExtraDim /> */}
    </>
  );
}

export default App;

function ModalExtraDim() {
  useEffect(() => {
    const ensureOverlay = () => {
      let overlay = document.getElementById('rb-extra-dim');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'rb-extra-dim';
        overlay.style.position = 'fixed';
        overlay.style.inset = '0';
        overlay.style.pointerEvents = 'none'; // clicks pass through to Bootstrap's own backdrop
        overlay.style.transition = 'opacity 120ms ease-out';
        overlay.style.display = 'none';
        document.body.appendChild(overlay);
      }
      return overlay;
    };

    const update = () => {
      const modals = Array.from(document.querySelectorAll < HTMLElement > ('.modal.show'));
      const overlay = ensureOverlay();

      if (modals.length < 2) {
        overlay.style.display = 'none';
        return;
      }

      // Find the top modal’s z-index
      const topModal = modals.reduce((acc, el) => {
        const z = parseInt(getComputedStyle(el).zIndex || '0', 10);
        const accZ = acc ? parseInt(getComputedStyle(acc).zIndex || '0', 10) : -1;
        return z > accZ ? el : acc;
      }, null);

      const topZ = topModal ? parseInt(getComputedStyle(topModal).zIndex || '1055', 10) : 1055;

      // Place our overlay *just below* the top modal, above everything else
      overlay.style.zIndex = String(topZ - 1);
      // Darken more as more modals open (cap at 0.85)
      const extraLayers = modals.length - 1;
      overlay.style.background = 'black';
      overlay.style.opacity = String(Math.min(0.5 + extraLayers * 0.12, 0.85));
      overlay.style.display = 'block';
    };

    const mo = new MutationObserver(() => requestAnimationFrame(update));
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'style',
      ],
    });

    update();
    return () => mo.disconnect();
  }, []);

  return null;
}
